export default "__VITE_ASSET__010cb2d8__"